import "./ContainChoose.css";
import img from "../containassets/chooseimg.png";

export default function ContainChoose() {
  return (
    <div id="contain-choose" className="outsourcemainclass">
      <div className="left">
        <div className="offer-item content content1">
          <h2>Key Benefits of DevOps Automated Testing</h2>
          <p>
            BastionEx delivers expert containerization services with proven
            DevOps and cloud experience. We provide secure, scalable, and
            compliant solutions, integrating containers into CI/CD pipelines.
            Our customized strategies ensure consistent deployments, optimized
            performance, simplified operations, and flexibility across
            on-premises, cloud, and hybrid environments, enabling faster
            application delivery and reliable system management.
          </p>
          <ul>
            <li>Proven expertise in DevOps and container technologies</li>
            <li>Secure, enterprise-grade container solutions</li>
            <li>Customized strategies aligned with business objectives</li>
            <li>Focus on scalability, reliability, and performance</li>
          </ul>
        </div>
      </div>
      <div className="right">
        <img src={img} alt="error" />
      </div>
    </div>
  );
}
